import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaJava, 
  FaDocker, 
  FaDatabase, 
  FaFigma, 
  FaBootstrap, 
  FaHtml5, 
  FaCss3, 
  FaJs, 
  FaReact 
} from 'react-icons/fa';
import { 
  SiKotlin
} from 'react-icons/si';

const Skills = () => {
  return (
    <SkillsSection>
      <SectionTitle>
        <span>04.</span> Skills
      </SectionTitle>
      <SkillsGrid>
        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaJava />
              <SiKotlin />
            </IconContainer>
            <CategoryTitle>Android Development</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaJava className="icon" /> Java</SkillItem>
            <SkillItem><SiKotlin className="icon" /> Kotlin</SkillItem>
          </SkillList>
        </SkillCategory>

        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaDocker />
            </IconContainer>
            <CategoryTitle>Cloud & DevOps</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaDocker className="icon" /> Docker</SkillItem>
          </SkillList>
        </SkillCategory>

        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaDatabase />
            </IconContainer>
            <CategoryTitle>Databases</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaDatabase className="icon" /> SQL</SkillItem>
            <SkillItem><FaDatabase className="icon" /> Azure SQL Database</SkillItem>
            <SkillItem><FaDatabase className="icon" /> Relational Database Design</SkillItem>
          </SkillList>
        </SkillCategory>

        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaFigma />
            </IconContainer>
            <CategoryTitle>Design</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaFigma className="icon" /> Figma</SkillItem>
            <SkillItem><FaFigma className="icon" /> Adobe XD</SkillItem>
          </SkillList>
        </SkillCategory>

        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaBootstrap />
            </IconContainer>
            <CategoryTitle>Front-End Frameworks</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaBootstrap className="icon" /> Bootstrap</SkillItem>
            <SkillItem><FaBootstrap className="icon" /> Material-UI</SkillItem>
          </SkillList>
        </SkillCategory>

        <SkillCategory
          whileHover={{ y: -5 }}
          transition={{ duration: 0.2 }}
        >
          <CategoryHeader>
            <IconContainer>
              <FaHtml5 />
              <FaCss3 />
              <FaJs />
              <FaReact />
            </IconContainer>
            <CategoryTitle>Web Development</CategoryTitle>
          </CategoryHeader>
          <SkillList>
            <SkillItem><FaHtml5 className="icon" /> HTML</SkillItem>
            <SkillItem><FaCss3 className="icon" /> CSS</SkillItem>
            <SkillItem><FaJs className="icon" /> JavaScript</SkillItem>
            <SkillItem><FaReact className="icon" /> React</SkillItem>
          </SkillList>
        </SkillCategory>
      </SkillsGrid>
    </SkillsSection>
  );
};

const SkillsSection = styled.section`
  min-height: 100vh;
  padding: 100px 0;
  background: #0a192f;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #ccd6f6;
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: 'Courier New', monospace;

  span {
    color: #64ffda;
    font-size: 1.5rem;
  }
`;

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  width: 100%;
`;

const SkillCategory = styled(motion.div)`
  background: #112240;
  padding: 2rem;
  border-radius: 4px;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
`;

const CategoryHeader = styled.div`
  margin-bottom: 1.5rem;
`;

const IconContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  color: #64ffda;
  font-size: 1.5rem;
`;

const CategoryTitle = styled.h3`
  color: #64ffda;
  font-size: 1.2rem;
  font-family: 'Courier New', monospace;
`;

const SkillList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SkillItem = styled.li`
  color: #8892b0;
  margin: 0.8rem 0;
  font-size: 1rem;
  font-family: 'Courier New', monospace;
  display: flex;
  align-items: center;
  gap: 1rem;

  .icon {
    color: #64ffda;
  }

  &:before {
    content: '▹';
    color: #64ffda;
  }
`;

export default Skills;
